import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { DynamicFormModule } from '@koomzo/dynamicforms';
import { NgxsModule } from '@ngxs/store';
import { AuthState } from '../store/auth.state';
import { AuthRoutingModule } from './auth-routing.module';
import * as fromComponents from './components/index';

// import { Facebook } from '@ionic-native/facebook/ngx';
// import { GooglePlus } from '@ionic-native/google-plus/ngx';
import * as fromServices from '../services/index';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngstack/translate';
import { TermsOfServiceModule } from '@app/common/terms-of-service/terms-of-service.module';
import { PrivacyPolicyModule } from '@app/common/privacy-policy/privacy-policy.module';
import { WalkthroughModule } from './walkthrough/walkthrough.module';

@NgModule({
  imports: [
    DynamicFormModule,
    SharedModule,
    TermsOfServiceModule,
    PrivacyPolicyModule,
    TranslateModule.forChild(),
    WalkthroughModule,
    NgxsModule.forFeature([AuthState]),
    // NgxsStoragePluginModule.forRoot({
    //   key: 'auth.token'
    // }),
    AuthRoutingModule
  ],
  declarations: [...fromComponents.authComponents],
  exports: [...fromComponents.authComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class AuthModule {
  constructor() {
    console.log('AuthModule loaded.');
  }

  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
     // providers: [...fromServices.authProviders, Facebook, GooglePlus]
      providers: [...fromServices.authProviders]
    };
  }
}
